var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-link',{attrs:{"icon":_vm.data.setting.icon,"type":_vm.data.setting.type,"disabled":_vm.data.setting.disabled,"underline":_vm.data.setting.underline,"href":_vm.data.setting.href,"target":_vm.data.setting.target}},[_vm._v(_vm._s(_vm.data.setting.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }